export default __webpack_public_path__ + "03de8a17744d513b218fd9c7b05697ea.svg";